import kamala from '../../kamala'
import ControlGroup from './ControlGroup'

const KControlGroup = {
  install: function (Vue) {
    kamala(Vue)
    Vue.component(ControlGroup.name, ControlGroup)
  },
}

export {
  ControlGroup,
}

export default KControlGroup
